import React, { PropsWithChildren } from "react";
import { AbleCommonProps } from "../../Types";
import { TableStatusMessageType } from "../types";
import TableInlineMessage from "./TableInlineMessage";
export type TableTopControlType = PropsWithChildren & TableStatusMessageType & AbleCommonProps;

const TableTopControls = (props: TableTopControlType) => {
    const { children } = props;
    const childArray: any = [];
    React.Children.forEach(children, (child: any) => {
        const displayName = child?.type?.displayName ?? '';
        if (displayName === 'TableFilters'
            || displayName === 'AppliedFilters'
            || displayName === 'TableActions'
        ) {
            childArray.push(child)
        }
    })

    return (
        <div className="ted-ui-TableFilterActions">
            <TableInlineMessage {...props} />
            {childArray}
        </div>
    )
}

TableTopControls.displayName = 'TableTopControls';

export default TableTopControls;